import styled from 'styled-components';
import { ErrorText } from '../../CreateCampign.styles';

export const CampaignTypeWrapper = styled.div`
    background-color: red;
`;

export const StyledErrorText = styled(ErrorText)`
    margin: -15px 4px 0;
`;
